import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {Layouts} from '../../app.component';
import {BusinessRulesComponent} from "./business-rules.component";
import {BusinessRuleViewComponent} from "../business-rule-view/business-rule-view.component";

const routes: Routes = [  {
    path : 'data-catalogue/business-rules',
    component : BusinessRulesComponent,
    data: { layout: Layouts.SecureLayout }
},
    {
        path: 'data-catalogue/business-rules/:ruleId',
        component: BusinessRuleViewComponent,
        data: { layout: Layouts.SecureLayout }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BusinessRulesRoutingModule { }